import styled, { system } from '@xstyled/styled-components';
var Frame = styled.div.withConfig({
  displayName: "Frame",
  componentId: "sc-1g3ndsf-0"
})(system);
Frame.defaultProps = {
  w: 'auto',
  h: 'auto',
  bg: 'material',
  boxShadow: 'out'
};
export default Frame;